let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("klVOv")).then(() => parcelRequire('2O82h'));